import {
  ConsortiaManagementTypes,
  SET_ERROR,
  SET_IS_LOADING,
  SET_SUBMITTED_SUCCESSFULLY,
  SET_CENTRE,
  SET_CONSORTIA,
  SET_CONSORTIUM,
  SET_FETCHING_CONSORTIA,
  SET_CONSORTIA_TOTAL,
  SET_VALIDATION,
  SET_NEXT_PAGE_URL,
  SET_SEARCH_VALUE,
  SET_FILTER_VALUE,
  RESET_STATE,
} from './types';
import { ConsortiaManagementState } from '../../types/ConsortiaManagement';
import { RESET_GLOBAL_STATE, GlobalActionTypes } from '../types';
import { unknown } from '../actions';

export const initialState: ConsortiaManagementState = {
  centre: undefined,
  consortium: undefined,
  consortia: [],
  isLoading: false,
  isSubmittedSuccessfully: false,
  hasError: false,
  fetchingConsortia: false,
  nextPageUrl: undefined,
  consortiaTotal: 0,
  searchValue: '',
  validation: {
    isNameUnique: true,
    isConsortiumUnique: true,
  },
  filter: {
    series: 'current',
  },
};

export default (
  state = initialState,
  action: ConsortiaManagementTypes | GlobalActionTypes = unknown(),
): ConsortiaManagementState => {
  switch (action.type) {
    case SET_CENTRE: {
      const { centre } = action.payload;

      return {
        ...state,
        centre: centre,
        isLoading: false,
      };
    }

    case SET_CONSORTIUM: {
      const { consortium } = action.payload;
      return {
        ...state,
        consortium,
      };
    }

    case SET_CONSORTIA: {
      const { consortia } = action.payload;
      return {
        ...state,
        consortia,
        isLoading: false,
      };
    }

    case SET_FILTER_VALUE: {
      const { value } = action.payload;
      return {
        ...state,
        filter: { series: value },
      };
    }

    case SET_IS_LOADING: {
      const { isLoading } = action.payload;

      return {
        ...state,
        isLoading: isLoading,
      };
    }

    case SET_SUBMITTED_SUCCESSFULLY: {
      const { value } = action.payload;

      return {
        ...state,
        isSubmittedSuccessfully: value,
      };
    }

    case SET_FETCHING_CONSORTIA: {
      const { value } = action.payload;

      return {
        ...state,
        fetchingConsortia: value,
      };
    }

    case SET_VALIDATION: {
      const { validation } = action.payload;

      return {
        ...state,
        validation,
      };
    }

    case SET_CONSORTIA_TOTAL: {
      const { count } = action.payload;

      return {
        ...state,
        consortiaTotal: count,
      };
    }

    case SET_NEXT_PAGE_URL: {
      const { url } = action.payload;

      return {
        ...state,
        nextPageUrl: url,
      };
    }

    case SET_SEARCH_VALUE: {
      const { value } = action.payload;

      return {
        ...state,
        searchValue: value,
      };
    }

    case SET_ERROR: {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    }

    case RESET_STATE: {
      return { ...initialState, filter: state.filter };
    }

    case RESET_GLOBAL_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
